export default {
    container: {
        position: 'relative',
    },
};


// WEBPACK FOOTER //
// ./src/components/input/DateRange/styles/DateRangePicker.js